import { useQuery } from '@tanstack/react-query'
import ms from 'ms'
import React from 'react'
import PBAPIClient from '../../../../../services/prime-client'
import { getCookie } from '../../../../../utilities/functions'
import { useDomainContext } from '../../../../../contexts/DomainContext'
import { useSelector } from 'react-redux'

const useWalletAccounts = () => {
    const authToken = getCookie("authToken")
    const companyId = getCookie("companyId")
    const userType = getCookie("userType")
    const userId = getCookie("userId")
    const { companyTheme } = useDomainContext();

    const linkName = companyTheme?.name || 'default';

    console.log("USERTYPE!!", companyTheme?.name)


    const idToUse = userType === "under-company" ? userId : companyId;

    const apiClient = new PBAPIClient(`/account/wallet-accounts/${idToUse}`, authToken, userType, linkName);


    return useQuery({
        queryKey: ["wallet-accounts"],
        queryFn: () => apiClient.get(),
        staleTime: ms("1h"),
        enabled: !!idToUse
    })

}

export default useWalletAccounts